import { Component, Input, OnInit } from '@angular/core';
import { Observable } from "rxjs";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Store } from '@ngrx/store';
import { selectDictionarySizes, selectOriginalDictionarySizes } from 'app/reducers/menu.selectors';
import {
  DisplayedProduct,
  DisplayedSize,
  DisplayedSizeStructure,
  Size
} from 'app/models/menu.model';
import { Organization } from 'app/models/organization.model';

@UntilDestroy()
@Component({
  selector: 'app-promo-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent implements OnInit {
  defaultPicture = 'assets/images/dishes/logo.png';

  @Input() product: DisplayedProduct;
  @Input() currentOrganization: Organization;
  @Input() cdkDragData: any;

    dictionarySizes$: Observable<Map<string, DisplayedSize>>;
  originalDictionarySizes$: Observable<Map<string, Size>>;

  priceValue = 0;
  hasPrice = true;
  productName = '';
  sizes: DisplayedSizeStructure[];
  dictionarySizes: Map<string, DisplayedSize>;
  originalDictionarySizes: Map<string, Size>;

  constructor(
    private store: Store,
  ) {
  }

  ngOnInit(){
    this.dictionarySizes$ = this.store.select(selectDictionarySizes);
    this.originalDictionarySizes$ = this.store.select(selectOriginalDictionarySizes);

    this.dictionarySizes$
      .pipe(
        untilDestroyed(this)
      )
      .subscribe(dictionarySizes => {
        this.dictionarySizes = dictionarySizes;
      });

    this.originalDictionarySizes$
      .pipe(
        untilDestroyed(this)
      )
      .subscribe(originalDictionarySizes => {
        this.originalDictionarySizes = originalDictionarySizes;
      });
  }

  getSizeName(sizeId: string) {
    return this.dictionarySizes.get(sizeId)?.name?.substring(0,10);
  }

  isChangedSize(sizeId: string): boolean{
    return this.dictionarySizes.get(sizeId).isChangedSize;
  }
}
